import React, { Component } from "react";
import { Container, Alert } from "react-bootstrap";
import Auth from "../../../Auth";
import Navbar from "../../../components/Navbar";
import SignOut from "../../SignOut";
import { link, goto, numb2 } from "../../link.js";
import axios from "axios";
import Footer from "../../footer";
import Loading from "../../loading";

const toNumber = (value) => {
  const number = Number.parseFloat(value);
  return Number.isNaN(number) ? 0 : number;
};

export class RoundInfo extends Component {
  constructor(props) {
    super(props);
    this.state = {
      round: {},
      totals: {},
      members: [],
      searchItem: "",
      loading: true,
      failed: false,
      available: true,
    };
    this.mounted = false;
  }

  componentDidMount() {
    this.mounted = true;
    this.getRound();
  }

  componentWillUnmount() {
    this.mounted = false;
  }

  requestedRoundId = () => {
    const segment = window.location.hash.split("/")[3] || "";
    try {
      return decodeURIComponent(segment);
    } catch (error) {
      return segment;
    }
  };

  handleDetails = (id) => {
    goto("Main/Memberdetails/" + id);
  };
  handleMigrateRond = (id) => {
    goto("Main/AddMemberRound/" + id);
  };
  handleContribution = () => {
    goto("Main/Contribution/" + this.state.round.roundID);
  };
  handleDistribution = () => {
    goto("Main/Distribution/" + this.state.round.roundID);
  };
  handleUserChange = (e) => {
    this.setState({ searchItem: e.target.value });
  };

  getRound = async () => {
    try {
      const response = await axios.post(
        `${link()}&do=getroundmembers&ra=round&ft=rec&id=${encodeURIComponent(this.requestedRoundId())}`,
        {},
        { timeout: 30000 }
      );
      const data = response.data;
      if (!this.mounted) return;
      if (data && data.available === true) {
        this.setState({
          round: data.round || {},
          totals: data.totals || {},
          members: Array.isArray(data.members) ? data.members : [],
          loading: false,
        });
      } else {
        this.setState({ available: false, loading: false });
      }
    } catch (error) {
      console.log(error);
      Auth.handleHttpCodes(error, "roundInfo");
      if (this.mounted) this.setState({ loading: false, failed: true });
    }
  };

  render() {
    const { round, totals, members, loading, failed, available, searchItem } = this.state;
    const search = searchItem.trim().toLowerCase();
    const visibleMembers = members.filter((member) => (member.names || "").toLowerCase().includes(search));
    const monthlyContribution =
      toNumber(round.savingContributionAmount) * toNumber(totals.totalshares) +
      toNumber(round.membershipContributionAmount) * toNumber(totals.membershipnumber);

    return (
      <div>
        <Navbar />
        <SignOut />

        <div className="contentdashbord">
          <br />
          <Container fluid>
            <h6 className="activejobs">Round Information</h6>
            {loading && <Loading />}
            {!loading && failed && (
              <Alert variant="danger" role="alert">The round information could not be loaded. Please try again.</Alert>
            )}
            {!loading && !failed && !available && <Alert variant="info">No active round is available.</Alert>}
            {!loading && !failed && available && (
              <div>
                <div className="searchadd">
                  <button className="btndistr " onClick={this.handleContribution}>
                    Contribution
                  </button>
                  <button className="btndistr" onClick={this.handleDistribution}>
                    Round Payment
                  </button>
                </div>
                <div className="activeuser">
                  <div className="row ">
                    <div className="col col-lg-4">
                      <div className=" conten">
                        Round Name:
                        <span className="unity">{round.name}</span>
                      </div>
                      <div className=" conten">
                        Start Date:
                        <span className="unity"> {round.startDate ? round.startDate.toString().substring(0, 10) : ""}</span>
                      </div>
                      <div className=" conten">
                        End Date:
                        <span className="unity">{round.endDate ? round.endDate.toString().substring(0, 10) : ""}</span>
                      </div>
                      <div className=" conten">
                        Number of Members:
                        <span className="unity">{totals.numberofMembers}</span>
                      </div>
                    </div>
                    <div className="col-lg-4">
                      <div className=" conten">
                        Value of a Share:
                        <span className="unity">
                          {round.currency} {numb2(round.shareValue)}
                        </span>
                      </div>
                      <div className=" conten">
                        Total Shares:
                        <span className="unity">{totals.totalshares}</span>
                      </div>
                      <div className=" conten">
                        Total Share Value:
                        <span className="unity">
                          {round.currency} {numb2(totals.valueshares)}
                        </span>
                      </div>
                    </div>
                    <div className="col col-lg-4">
                      <div className=" conten">
                        Round Payment Shares:
                        <span className="unity">{totals.membershipnumber}</span>
                      </div>
                      <div className=" conten">
                        Round Payment Share Value:
                        <span className="unity">
                          {round.currency} {numb2(round.membershipContributionAmount)}
                        </span>
                      </div>
                      <div className="col conten">
                        Mothly Reserve Shares:
                        <span className="unity">{totals.totalshares}</span>
                      </div>
                      <div className="col conten">
                        Value of Reserve Share:
                        <span className="unity">
                          {round.currency} {numb2(round.savingContributionAmount)}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>

                <div className=" cardtable">
                  <div className="containeruserscroll">
                    <div className="membadd d-flex">
                      <p className=" contentmemb">Members</p>
                      <input
                        type="text"
                        id="search"
                        className="loginsearchfaro"
                        placeholder=" Search a name..."
                        aria-label="Search a name"
                        onChange={this.handleUserChange}
                      />
                      <div
                        className="btnaddblogadds "
                        onClick={() => this.handleMigrateRond(round.roundID)}
                      >
                        <i className="fas fa-plus"></i>
                      </div>
                    </div>

                    <table className="table table-hover  table-responsive  tablealot">
                      <thead>
                        <tr>
                          <th className="userprony ">Names</th>
                          <th className="userprony ">Shares</th>
                          <th className="userprony ">Value of Shares</th>
                          <th className="userprony ">
                            Round Payment
                            <br />
                            Shares
                          </th>
                          <th className="userprony ">Reserve Shares</th>
                          <th className="userprony ">
                            Monthly
                            <br />
                            Contribution{" "}
                          </th>
                          <th className="userprony ">
                            Actual
                            <br /> Social Capital
                          </th>
                          <th className="userprony ">
                            Capital
                            <br />
                            Balance
                          </th>
                          <th className="userprony ">Commission</th>
                          <th className="userprony ">
                            {" "}
                            Commission
                            <br />
                            Balance
                          </th>
                          <th className="userprony "></th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td className="userpronou "></td>
                          <td className="userpronou ">{numb2(totals.totalshares)}</td>
                          <td className="userpronou ">{numb2(totals.valueshares)}</td>
                          <td className="userpronou ">{numb2(totals.membershipnumber)}</td>
                          <td className="userpronou ">{numb2(totals.totalshares)}</td>
                          <td className="userpronou ">{numb2(monthlyContribution)}</td>
                          <td className="userpronou ">{numb2(totals.actualcapital)}</td>
                          <td className="userpronou ">{numb2(totals.capitalbalance)}</td>
                          <td className="userpronou ">{numb2(totals.commission)}</td>
                          <td className="userpronou ">{numb2(totals.commissionblance)}</td>
                          <td className="d-flex"></td>
                        </tr>

                        {visibleMembers.map((member) => (
                          <tr key={member.memberID}>
                            <td className="userpronyblue ">{member.names}</td>
                            <td className="userpronyblue ">{member.numberOfShares}</td>
                            <td className="userpronyblue "> {numb2(member.sharesValue)}</td>
                            <td className="userinfo "> {member.numberOfMemberships}</td>
                            <td className="userinfo ">{numb2(member.numberOfSavings)}</td>
                            <td className="userinfo ">{numb2(member.monthlycontribution)}</td>
                            <td className="userinfo ">{numb2(member.capitalpaid)}</td>
                            <td className="userinfo ">{numb2(member.capitalbalance)}</td>
                            <td className="userinfo ">{numb2(member.commissionTermAmount)}</td>
                            <td className="userinfo ">{numb2(member.commissionbalance)}</td>
                            <td className="userinfo ">
                              <span
                                className="viewdetclionedit mr-2"
                                onClick={() => this.handleDetails(member.memberID + "/member/memberround")}
                              >
                                Details
                              </span>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            )}
          </Container>
        </div>

        <br />

        <Footer />
      </div>
    );
  }
}

export default RoundInfo;
